var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.1,9.3v5.2c0,1.3-1,2.4-2.2,2.6V19c0,0.7-0.3,1.2-0.8,1.4c-0.1,0.1-0.3,0.1-0.5,0.1c-0.4,0-0.8-0.1-1.1-0.5 l-2.9-2.9H9.4c-0.1,0-0.2,0-0.4-0.1l2.2-2.2h3.1l2.2,2.2v-2.2h1.9c0.2,0,0.4-0.2,0.4-0.4V6.7C20.1,6.9,21.1,8,21.1,9.3z M10.6,13.4 l-2.9,2.9c-0.3,0.3-0.8,0.5-1.1,0.5c-0.2,0-0.3,0-0.5-0.1c-0.5-0.2-0.8-0.8-0.8-1.4v-1.9C4,13.3,3,12.2,3,10.9V5.6 C3,4.2,4.2,3,5.6,3h9c1.4,0,2.6,1.2,2.6,2.6v5.2c0,1.4-1.2,2.6-2.6,2.6L10.6,13.4L10.6,13.4z M9.8,11.2h4.9c0.2,0,0.4-0.2,0.4-0.4 V5.6c0-0.2-0.1-0.4-0.4-0.4h-9c-0.2,0-0.4,0.1-0.4,0.4v5.2c0,0.2,0.2,0.4,0.4,0.4h1.9v2.2L9.8,11.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default ForwardRef;